module.exports = __webpack_public_path__ + "img/icon-notif-dot.7fd6e978.svg";